import lazyScreen from '../utils/lazyScreen';
const ARServeStatuses = lazyScreen(() => import('../pages/serve/ARServeStatuses/index.js'), 'pages/serve/ARServeStatuses/index.js');
const ARServeCookings = lazyScreen(() => import('../pages/serve/ARServeCookings/index.js'), 'pages/serve/ARServeCookings/index.js');
const ARServeCooking = lazyScreen(() => import('../pages/serve/ARServeCooking/index.js'), 'pages/serve/ARServeCooking/index.js');
const ARServeCookingV2 = lazyScreen(() => import('../pages/serve/ARServeCookingV2/index.js'), 'pages/serve/ARServeCookingV2/index.js');
const ARServeDeliveryV2 = lazyScreen(() => import('../pages/serve/ARServeDeliveryV2/index.js'), 'pages/serve/ARServeDeliveryV2/index.js');
const ARServeServices = lazyScreen(() => import('../pages/serve/ARServeServices/index.js'), 'pages/serve/ARServeServices/index.js');
const ARServeService = lazyScreen(() => import('../pages/serve/ARServeService/index.js'), 'pages/serve/ARServeService/index.js');
const ARServeAlwnRule = lazyScreen(() => import('../pages/serve/ARServeAlwnRule/index.js'), 'pages/serve/ARServeAlwnRule/index.js');
const ARServeMonthlyReports = lazyScreen(() => import('../pages/serve/ARServeMonthlyReports/index.js'), 'pages/serve/ARServeMonthlyReports/index.js');
const ARServeMaterialIssue = lazyScreen(() => import('../pages/serve/ARServeMaterialIssue/index.js'), 'pages/serve/ARServeMaterialIssue/index.js');
const ARServeMaterialIssues = lazyScreen(() => import('../pages/serve/ARServeMaterialIssues/index.js'), 'pages/serve/ARServeMaterialIssues/index.js');
const ARServeMaterialCounting = lazyScreen(() => import('../pages/serve/ARServeMaterialCounting/index.js'), 'pages/serve/ARServeMaterialCounting/index.js');
const ARServeMaterialCountings = lazyScreen(() => import('../pages/serve/ARServeMaterialCountings/index.js'), 'pages/serve/ARServeMaterialCountings/index.js');
const ARServeBOM = lazyScreen(() => import('../pages/serve/ARServeBOM/index.js'), 'pages/serve/ARServeBOM/index.js');

export default [
    {
        path: '/serve/ARServeStatuses',
        component: ARServeStatuses
    },
    {
        path: '/serve/ARServeCookings',
        component: ARServeCookingV2
    },
    {
        path: '/serve/ARServeDeliveries',
        component: ARServeDeliveryV2
    },
    {
        path: '/serve/ARServeCookingsLegacy',
        component: ARServeCookings
    },
    {
        path: '/serve/ARServeCooking/:code',
        component: ARServeCooking
    },
    {
        path: '/serve/ARServeServices',
        component: ARServeServices
    },
    {
        path: '/serve/ARServeService/:code',
        component: ARServeService
    },
    {
        path: '/serve/ARServeAlwnRule/:code',
        component: ARServeAlwnRule
    },
    {
        path: '/serve/ARServeMonthlyReports',
        component: ARServeMonthlyReports
    },
    {
        path: '/serve/ARServeMaterialIssue/:code',
        component: ARServeMaterialIssue
    },
    {
        path: '/serve/ARServeMaterialIssues',
        component: ARServeMaterialIssues
    },
    {
        path: '/serve/ARServeMaterialCounting/:code',
        component: ARServeMaterialCounting
    },
    {
        path: '/serve/ARServeMaterialCountings',
        component: ARServeMaterialCountings
    },
    {
        path: '/serve/ARServeBOM/:code',
        component: ARServeBOM
    }
];
